import { POST_FORM_DETAILS } from "../actionTypes";

export function postDetails(data, callback) {
  return {
    type: POST_FORM_DETAILS,
    data,
    callback
  };
}
